var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"flex-img__image",attrs:{"width":"100%","height":"100%","src":_vm.slideUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }